import { serviceRequest } from './service-request';

export function getSessionInfo() {
	// TODO: [MFT] remove setting bypassCaptcha when the Wordpress plugin is updated to use the oauth process
	return serviceRequest('svc/session/info', null, { method: 'GET', bypassCaptcha: true });
}

export function changeOrganization(id: string) {
	return serviceRequest('svc/session/change-organization', { id });
}

export function logout() {
	return serviceRequest('svc/session/logout', { });
}

export function getOrganizations() {
	return serviceRequest('svc/session/organizations', null, { method: 'Get' });
}